import {
  PopoverBody,
  Popover as ChakraPopover,
  PopoverTrigger,
  PopoverContent,
} from '@chakra-ui/popover';
import { Portal } from '@chakra-ui/portal';
import { Icon } from 'components';
import React, { memo, MouseEventHandler, useCallback, useState } from 'react';

import * as Styles from './styles';

interface IProps {
  rows: any[];
  disabled?: boolean;
}

const PopoverComponent: React.FC<IProps> = ({ rows, disabled }) => {
  const [isOpen, setIsOpen] = useState<boolean>(false);

  const handleClickLine = useCallback<MouseEventHandler<HTMLLIElement>>(e => {
    e.stopPropagation();
    e.preventDefault();

    setIsOpen(false);
  }, []);

  return (
    <ChakraPopover
      placement="bottom-end"
      isOpen={isOpen}
      onClose={() => !disabled && setIsOpen(false)}
      onOpen={() => !disabled && setIsOpen(true)}
    >
      <PopoverTrigger>
        <Styles.IconContainer disabled={disabled}>
          <Icon
            name="moreVert"
            size={1.3}
            clickable={!disabled}
            color={disabled ? 700 : isOpen ? 900 : 600}
          />
        </Styles.IconContainer>
      </PopoverTrigger>
      <Portal>
        <PopoverContent>
          <PopoverBody>
            <Styles.Ul>
              {rows.map(
                (row, index) =>
                  !row.disabled && (
                    <Styles.Li
                      key={`row-${index}`}
                      onClick={e => {
                        handleClickLine(e);
                        row.onClick(e);
                      }}
                    >
                      {row.label}
                    </Styles.Li>
                  ),
              )}
            </Styles.Ul>
          </PopoverBody>
        </PopoverContent>
      </Portal>
    </ChakraPopover>
  );
};

export const Popover = memo(PopoverComponent);
